
import {  Modal, Select, Tooltip } from "antd";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import styles from "../../../contacts/contactWidgets/contactFiles/filelistcenter.module.scss";
import { ChatService } from "../../../../base/chatService";
import { Cookie, downloadAttachment, excelFormats, getcontactDetail, getFileSize, 
  pdfFormats, pptFormats, SearchFilter, videoFormat, wordFormats, zipFormats } from "../../../../base/utils";
import { Types } from "../../../../context/action/action";
import store from "../../../../context/store/store";
import { contacts, contactwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../../models/model";
import { URButton } from "../../../../shared/widgets/button";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../../base/callService/common";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { useSelector } from "react-redux";
import { SocketChatService } from "../../../../base/socketChatService";
import { config } from "../../../../base/constant";
import { browserName, browserVersion } from "react-device-detect";
import teamIcn from "../../../../styles/images/teamimg.svg";
type filePreviewprops={
  isOpen?:any;
  data?:any;
  previewopen:Function;
  groupdata?:any;
 
}

type filepreviewstate ={
  isopenmodel:boolean;
  filterIndex:any;
  deleteModelOpen:boolean;
  sharemodelopen:boolean;
  contactList: Array<any>;
  searchContactList: Array<any>;
  selectedmember: Array<any>;
  contactDetail:Array<any>;
  previewDeleteData:any;
  deletingFileInfo:any;
  fileDescription:string;
}
export default function AllFilePreview({isOpen,data,previewopen,groupdata}:filePreviewprops) {
  let {allContacs} :contacts = store.getState().contactReducer;
  const chatWindow :contactwindowDetails = useSelector((state:initialStateModel)=>state.contactWindowReducer);
  let { contactFileList } = chatWindow;
  let {userdetails}:LoginState = store.getState().loginReducer;
  const contact: rightSidePanelDetails = useSelector((state: initialStateModel) =>
  state.chatRightSidePanelReducer);
  let {fileListDetails}=contact;

  const socketChat = useRef<any>(null);
  useEffect(()=>{
    const userInfo:any =Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if(userInfosess){
      const cookieData =JSON.parse(userInfosess);
      socketChat.current= new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  },[])

  groupdata = _.filter(groupdata,((list)=>{
    return (list.message.messageType ==='FILE' && 
    list.message.messageType !== 'DELETED') ;}));
 
  const filemodelClose=()=>{
    setpreviefiles({...previefiles,isopenmodel:false});
    previewopen(false);
  };
  
  const deletepreviewFile =()=>{
    if(_.isArray(contactFileList)&&!(_.isUndefined(contactFileList))){
      socketChat.current.deleteForEveryone(data.id);
      setpreviefiles({...previefiles,deleteModelOpen:false,isopenmodel:false});
      if (window.location.pathname === "/contacts") {
        let prvDeletedFile = _.findIndex(contactFileList, ((ele: any) => {
          return _.isUndefined(ele === false) ? ele?.id === data?.id : {}
        }));
        contactFileList.splice(prvDeletedFile, 1)
        store.dispatch({
          type: Types.CONTACT_FILES_LIST,
          payload: {
            isContactFile: true,
            contactFileList: contactFileList
          }
        })
      } else {
          let prvDeletedFile = _.findIndex(fileListDetails, ((ele: any, index: any) => { return ele?.id === data?.id; }));
          fileListDetails.splice(prvDeletedFile, 1)
          store.dispatch({
            type: Types.GET_FILES_LIST,
            payload: {
              isfile: true,
              fileListDetails: fileListDetails
            }
          });
      }
}
    toastInformation(config().FILEDELETED, 'success');
  };
 
  let filterArray = _.filter(groupdata,((datas:any)=>{
    let messageBody = datas?.message.body;
    return pdfFormats.indexOf(messageBody.fileType) !== -1 ||
    wordFormats.indexOf(messageBody.fileType) !== -1 ||
    pptFormats.indexOf(messageBody.fileType) !== -1 ||
    excelFormats.indexOf(messageBody.fileType) !== -1
    }));
  
  let filterIndex =_.findIndex(filterArray,((ele:any)=>{
  return ele.id === data.id; }));
 
  const [previefiles, setpreviefiles] = useState<filepreviewstate>({
    isopenmodel:isOpen,filterIndex:filterIndex,deleteModelOpen:false,sharemodelopen:false, selectedmember: [],
    contactList: allContacs, searchContactList: allContacs,contactDetail:[],
    previewDeleteData:contactFileList,deletingFileInfo:data,fileDescription:""});
  useEffect(() => {
    setpreviefiles({...previefiles,filterIndex:previefiles.filterIndex});
  }, [previefiles.filterIndex]);

  const downloadAlfilesfromAttach = (filedata:any) => {
    downloadAttachment(filedata);
    filemodelClose()
    toastInformation('Success! File downloaded', 'success');
  };
  const confirmDelete = ()=>{
    setpreviefiles({...previefiles,deleteModelOpen:true});
  };
  const closeSelection =()=>{
    let deletedArray:any=[];
 
  
    store.dispatch({
      type: Types.SELECT_MESSAGE_ARRAY,
      payload: {
        selectMessageData:deletedArray
      }
    });
 
    setpreviefiles({...previefiles,deleteModelOpen:false});
  };
  const handleCancelforShare=()=>{
    setpreviefiles({...previefiles,sharemodelopen:false,contactDetail :[],selectedmember:[],fileDescription:""});
  };
  const onChangeSelectMembers =(e:any)=>{
  
    let {userdetails}:LoginState = store.getState().loginReducer;
    let contact:any=
    e.map((item:string)=>
    {
      return getcontactDetail(item.toString(),previefiles.contactList,userdetails);
    });
    
    
    
    setpreviefiles({
      ...previefiles, selectedmember: e,
      searchContactList: previefiles.contactList,contactDetail:contact
    });
   
  };
  const onSearchMembers = (value: any) => {
    let response = SearchFilter(previefiles.contactList, value.toLowerCase());
    setpreviefiles({ ...previefiles, searchContactList: response });

  };
  const likeMessage = (likeData: any,fileRes:any) => {
    let input = {
      id: fileRes.id,
      likeStatus: likeData
    };
    socketChat.current.likeMessageInfo(input);
  };
  const saveMessage = (status: any,fileRes:any) => {
    if(status===1){
      toastInformation("Sucess! Message saved");
    }
    let isBookmark = {
      id: fileRes.id,
      saveStatus: status
    };

    socketChat.current.bookMarkMesseage(isBookmark);
    status === 1 && toastInformation('Sucess! Message saved','success');
  };
  const shareFile =()=>{
    if (previefiles.selectedmember.length < 1 ) return toastInformation("No contacts selected", "warning");
    const sampledate = [];
    sampledate.push(filterArray[previefiles.filterIndex]);
    ChatService.forwardMessage(sampledate,previefiles.contactDetail);
    toastInformation('File shared successfully', 'success');
    setpreviefiles({...previefiles,sharemodelopen:true,contactDetail :[],selectedmember:[],fileDescription:"",isopenmodel:false});
    filemodelClose();
  };
  let pdfURL='';
  let messageBody = filterArray[previefiles.filterIndex]?.message?.body;
  let filePath = messageBody?.filePath;
  pdfURL=filePath;  
  let driveUrl='';
let extension = messageBody?.fileName.split('.').pop();
// let driveUrl= wordFormats.indexOf(messageBody?.fileType) !== -1? `http://view.officeapps.live.com/op/embed.aspx?src=${pdfURL}`:
// `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfURL}#toolbar=0&scrollbar=0`;
// let driveUrl= wordFormats.indexOf(messageBody?.fileType) !== -1? ` https://view.officeapps.live.com/op/embed.aspx?src=${pdfURL}`:
// `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfURL}`;

if(navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1)
{
if(browserVersion === '13' && (extension==='xls' || extension==='xlsx' || extension==='csv'))
{
driveUrl= `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfURL}`;
}else{
driveUrl= `https://view.officeapps.live.com/op/embed.aspx?src=${pdfURL}`;
}
}else{
  if(extension==='csv' || extension==='txt'|| extension==='docx' )
    {
      driveUrl= `https://docs.google.com/viewer?url=${pdfURL}&embedded=true`;
    }else {
      driveUrl= `https://view.officeapps.live.com/op/embed.aspx?src=${pdfURL}`;
    }
}
const openReplyMessage = (data:any) => {
  ChatService.onChangeReplyWindow(true, data);
  filemodelClose()
};
//let driveUrl = `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfURL}#toolbar=0&scrollbar=0`;
let len = Math.ceil((previefiles?.searchContactList?.length / 8));
let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
let previewFiles=messageBody?.fileType ==='application/pdf'? pdfURL : driveUrl;
let fileRes:any = filterArray[previefiles.filterIndex]; 
let LikeObeject: any = fileRes?.message?.liked || [];
let isBookmark: any = fileRes?.message?.isSave || [];
let isLike = (LikeObeject && LikeObeject["s" + userdetails.sip_login_id]) || 0;
let savedBookmark = (isBookmark && isBookmark["s" + userdetails.sip_login_id]) || 0;

const maxFileNameLength = 20; 

  const truncateFileName = (fileName:any) => {
      if (typeof fileName === 'string' && fileName?.length > maxFileNameLength) {
      const extensionIndex = fileName?.lastIndexOf('.');
      if (extensionIndex !== -1) {
        const nameWithoutExtension = fileName?.slice(0, extensionIndex);
        const truncatedName = nameWithoutExtension?.slice(0, maxFileNameLength - 3);
        const extension = fileName?.slice(extensionIndex);
        return truncatedName + '...' + extension;
      } else {
        return fileName?.slice(0, maxFileNameLength - 3) + '...'; 
      }
    }
    return fileName;
  };

  return (
    <>
      
      <Modal visible={previefiles.isopenmodel} className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>{messageBody?.fileName}</h2>
          <ul>
            {/* <li onClick={() => openReplyMessage(fileRes)}> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Reply'}>
              <span className="iconReply">
              </span></Tooltip></li> */}
            <li onClick={() => saveMessage((savedBookmark === 0 ? 1 : 0),fileRes)}> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ? "Save Chat" : "UnSave chat"}>
              <span className={savedBookmark === 0?"iconSaveChat":"iconUNSaveChat"}></span></Tooltip></li>
              <li onClick={() => likeMessage((isLike === 0 ? 1 : 0),fileRes)}> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={isLike === 0 ? "Like" : "Unlike"}>
              <span className="iconLike" ></span></Tooltip></li>
           
            <li><Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Download'}>
              <span className="iconDownloadstroke" onClick={()=>downloadAlfilesfromAttach(data)}></span></Tooltip></li>


            {(window.location.pathname.includes('contact') && userdetails?.sip_login_id.toString() === filterArray[previefiles.filterIndex]?.from.toString() ?
              <Tooltip mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                <li><span className="iconDelete" onClick={confirmDelete}></span></li></Tooltip> :

              window.location.pathname.includes('chat') && userdetails?.sip_login_id.toString() === filterArray[previefiles.filterIndex]?.from.toString() &&
              <Tooltip mouseEnterDelay={0.5} title='Delete' className='cusTooltip' overlayClassName='customTooltip'>
                <li><span className="iconDelete" onClick={confirmDelete}></span></li></Tooltip>
            )}
            <li> <Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Share'}>
              <span className="iconShare" onClick={()=>
                 setpreviefiles({...previefiles,sharemodelopen:true})
               }></span></Tooltip></li>
              {/* <li> <Tooltip overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'More'}>
              <span className="iconOverflowH" ></span></Tooltip></li> */}
            <li><Tooltip className='cusTooltip' overlayClassName='customTooltip' mouseEnterDelay={0.5} placement="top" title={'Close'}
            >
              <span className="iconClose" onClick={filemodelClose}>
              </span></Tooltip></li>
              
          </ul>
  
        </div>
        <div className="chatNoteImgContent">
          <iframe title="File"
          allow="geolocation 'self' https://drive.google.com https://view.officeapps.live.com"
            src={previewFiles}
            frameBorder="0"
            scrolling="auto"
            height="400"
            width="100%"
          ></iframe>
        </div>
        
      </Modal>
      <Modal title="Delete file"
        centered
        visible={previefiles.deleteModelOpen}
        onOk={deletepreviewFile}
        onCancel={closeSelection}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete the selected file?
      </Modal>
      <Modal visible={previefiles.sharemodelopen} className={`${styles.addmembermodal} ${"modaloverwrite"}`}>
        <div className={styles.drop}>
          <span className={`icon_close ${styles.cursorTop}`}
            onClick={handleCancelforShare}></span>
          <h2>Share this file</h2>
          <div className={styles.insideicon}>
            <Select
              mode="multiple"
              onChange={(e: any) => onChangeSelectMembers(e)}
              onSearch={onSearchMembers}
              style={{ width: '100%' }}
              filterOption={false}
              showSearch={true}
              value={previefiles.selectedmember}
              placeholder="Search Name/ Group/ Extension"
              className="createNewSel "
              dropdownClassName="newChatSel taskcreations">
              { previefiles?.searchContactList?.map((contact:any,index:any)=>{
               
                let name= contact?.caller_id ?contact?.caller_id : contact?.team_name;
                return(
             
                  <option key={index}
                    value={contact?.sip_login_id?contact?.sip_login_id: `con${contact?.team_id}`}>
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                      {contact?.team_id ? <URAvatarGroup className={`lefts size20 colorBG${random_color[index]} 
                    ${(contact?.profile_image_url!== null && contact?.profile_image_url !== "")?'avatarWithImg':""}`}
                    profileInfo={ <> {contact?.profile_image_url ?
                      <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>:
                      <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> } </>  }
                  /> :    <URAvatarGroup
                  className={`lefts size20 colorBG${random_color[index]} ${(contact?.ImageURL!== null && contact?.ImageURL !== "")?'avatarWithImg':""}`}
                  profileInfo={
                    <>
                      {contact?.ImageURL || contact?.profile_image_url ? (
                        <>
                          <img alt="" src={contact?.ImageURL ? contact.ImageURL : contact?.profile_image_url} />
                          <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                        </>
                      ) : (
                        <span>
                          {contact?.first_name?.charAt(0).toUpperCase()+contact?.last_name?.charAt(0).toUpperCase()}
                          <URStatusDot className={userStatusColor(contact?.user_status, "small")} />
                        </span>
                      )}
                    </>
                  }
                />}
                      </div>
                      <div className="names">{name && name}</div>
                      {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                    </div>
                  </option>
              
                );

            
              })  }
         
            </Select>
            {/* <div className={styles.insideicon}>
           <TextArea rows={3} title="Add a message, if you'd like." placeholder="Add a message, if you'd like."
              onChange={(e)=>addFileDescription(e)} className="notesArea"/>
          </div> */}
          
        </div>
          <div className={styles.lftImfseccont}>
            {
              zipFormats.indexOf(messageBody?.fileType) !== -1 ?
                <img src={iconzip} alt=""/>
                :
                pdfFormats.indexOf(messageBody?.fileType) !== -1 ?
                  <img src={iconpdf} alt=""/>:
                  videoFormat.indexOf(messageBody?.fileType) !== -1 ?
                    <img src={iconpdf} alt=""/>:
                    wordFormats.indexOf(messageBody?.fileType) !== -1 ?
                      <img src={iconword} alt=""/>:
                      pptFormats.indexOf(messageBody?.fileType) !== -1 ?
                        <img src={iconppt} alt=""/>:
                        // mp3Formats.indexOf(messageBody?.fileType)!== -1  ?
                        //   <img  src={iconmusic} alt="" />:
                        excelFormats.indexOf(messageBody?.fileType) !== -1&&
            
            <img src={iconxls} alt=""/>}
            <p><span>{truncateFileName(messageBody?.fileName)}</span>
              <span>File size:{getFileSize(messageBody?.filesize)}</span></p>
          </div>
          <div className={styles.footersection}>
            <URButton className="urButton buttonWhite"
              
              name="Cancel" onClick={handleCancelforShare}></URButton>
            <URButton className="urButton buttonBlue marlftmin" onClick={shareFile} name="Share"></URButton>
          </div>
        </div>
      </Modal>
    </>
  );}